<template>
  <div :class="{ 'caderno-lateral' : cadernoLateral.status }">
    <div class="row align-items-center">
      <div class="col-12 text-center">
        <textarea name="anotacoes" class="form-control anotacoes-aula" placeholder="Faça aqui suas anotações" v-model="anotacao"></textarea>
      </div>
    </div>
    <div class="text-center" :class="{ 'buttons-caderno' : cadernoLateral.status }">
      <template v-if="isVideo">
        <button class="btn btn-secondary mx-2 mt-4" @click="alteraCadernoLateral()">
          <i class="fas fa-save mr-1"></i>
          {{ cadernoLateral.status && 'Ver em baixo' || 'Lado a lado'}}
        </button>
      </template>
      <template v-if="submit">
        <button class="btn btn-secondary mx-2 mt-4 disabled" disabled="disabled">
          <i class="fas fa-spinner fa-spin"></i> Salvando...
        </button>
      </template>
      <template v-else>
        <button class="btn btn-secondary mx-2 mt-4" ref="salvarAnotacao" @click="salvarAnotacao()">
          <i class="fas fa-save mr-1"></i> Salvar
        </button>
      </template>
      <button v-if="!cadernoLateral.status" class="btn btn-secondary mx-2 mt-4" @click="$bvModal.show('modalCaderno')">
        <i class="fas fa-book-open mr-1"></i> Ver caderno da lição
      </button>
    </div>

    <modal-caderno :licao="licaoCaderno" />
  </div>
</template>

<script>
import ModalCaderno from '@/core/components/ModalCaderno'
import AnotacoesAPI from '@/api/anotacoes-api'
import PerfilAPI from '@/api/perfil-api'

export default {
  name: 'MeuCaderno',
  components: { ModalCaderno },
  props: {
    anotacoes: String,
    ementaId: Number,
    licao: Object,
    isVideo: Boolean
  },
  data () {
    return {
      anotacao: '',
      submit: false,
      licaoCaderno: null
    }
  },
  mounted () {
    this.listarCadernos(this.licao)
    if (this.cadernoLateral.anotacao !== '') {
      this.anotacao = this.cadernoLateral.anotacao
    } else {
      this.anotacao = this.anotacoes
    }
    window.eventBus.$on('salvarAnotacao', () => {
      this.salvarAnotacao()
    })
  },
  methods: {
    salvarAnotacao: function () {
      this.submit = true
      AnotacoesAPI.obterAnotacao(this.ementaId).then(data => {
        if (!this.anotacao.length) {
          AnotacoesAPI.removerAnotacao(this.ementaId).then(() => {
            this.submit = false
            window.eventBus.$emit('anotacaoSalva')
          }).then(() => this.listarCadernos(this.licao))
        } else {
          if (data.data && data.data.length) {
            AnotacoesAPI.atualizarAnotacao(this.ementaId, this.anotacao).then(() => {
              this.submit = false
              window.eventBus.$emit('anotacaoSalva')
            }).then(() => this.listarCadernos(this.licao))
          } else {
            AnotacoesAPI.enviarAnotacao(this.ementaId, this.anotacao).then(() => {
              this.submit = false
              window.eventBus.$emit('anotacaoSalva')
            }).then(() => this.listarCadernos(this.licao))
          }
        }
      })
    },

    alteraCadernoLateral: function () {
      this.$store.dispatch('alternaCadernoLateral', this.anotacao)
    },

    listarCadernos: async function (licao) {
      const licaoCaderno = await PerfilAPI.listarMeusCadernos().then(data => {
        // TODO Atencao aqui! Essa api pode mudar pois o response dela esta retornando tanto as categorias, quanto os cadernos.
        if (data.length > 1) {
          const cursos = data[1].filter(item => item.id === licao.curso.id)

          let licoes = []
          cursos.forEach(c => {
            licoes.push(...c.modulos.flatMap(modulo => modulo.licoes))
          })

          const topicosLicao = licoes.filter(item => item.id === licao.id).flatMap(item => item.topicos)

          return { id: licao.id, nome: licao.nome, topicos: topicosLicao }
        }
      }).catch(() => {
        // do nothing
      })

      if (licaoCaderno) {
        this.licaoCaderno = Object.assign(licaoCaderno, licao)
        licaoCaderno.topicos.forEach(topico => {
          if (topico.ementaId === this.ementaId) {
            this.anotacao = topico.anotacoes[0].nome
          }
        })
      } else {
        this.licaoCaderno = licao
      }
    }
  },
  watch: {
    anotacoes: function (novaAnotacao) {
      this.anotacao = novaAnotacao
    },

    '$route.params': function () {
      // Como a pagina inteira nao e carregada, resetamos o data deste componente quando os parametros da rota sao alterados
      Object.assign(this.$data, this.$options.data.apply(this))
    },

    licao: function (value) {
      this.listarCadernos(value)
    }
  },
  computed: {
    cadernoLateral: function () {
      return this.$store.getters.caderno_lateral
    }
  }
}
</script>

<style scoped>

</style>
